import { render, staticRenderFns } from "./SupportReview.vue?vue&type=template&id=7de9d3e9&scoped=true"
import script from "./SupportReview.vue?vue&type=script&lang=js"
export * from "./SupportReview.vue?vue&type=script&lang=js"
import style0 from "./SupportReview.vue?vue&type=style&index=0&id=7de9d3e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9d3e9",
  null
  
)

export default component.exports